export default "__VITE_ASSET__Cgdeh95a__"